import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { getEmployment, patchScheduledHours, postScheduledHours } from '../../../../../global/ducks/benadmin-api';
import { formatDate, MinDate, parseChanged } from '../../../../../global/helpers/form-data-helper';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { ScheduledHours } from '../../employment/employment-model';
import { dispatchSetEmployment, dispatchSetEmploymentFailed, setDecreaseInScheduledHoursStatus, setUpdateScheduledHoursStatus, updateScheduledHours } from '../../employment/employment-slice';
import { ScheduledHoursFormValues } from './scheduled-hours-form-model';

export const postScheduledHoursRequest = (
	dispatch: Dispatch<any>,
	employeeId: number | string,
	employmentId: number,
	savedValues: ScheduledHoursFormValues,
	formValues: ScheduledHoursFormValues,
	currentScheduledHours: ScheduledHours,
	onSuccess: any,
) => {

	const changed = parseChanged(savedValues, formValues);

	const previousCompareDate = currentScheduledHours?.end_date || currentScheduledHours?.start_date || formatDate(MinDate);

	if (isEmpty(changed) || formatDate(formValues.start_date) <= formatDate(previousCompareDate)) {
		return;
	}

	dispatch(apiErrorClear());

	const postPayload: any = {
		scheduled_hour: {
			hours: formValues.hours,
			start_date: formatDate(formValues.start_date),
		},
	};
	if (formValues?.changeDueToIllness) {
		postPayload.scheduled_hour.change_due_to_illness = formValues?.changeDueToIllness;
	}
	if (formValues?.extenuatingCircumstances) {
		postPayload.scheduled_hour.extenuating_circumstances = formValues?.extenuatingCircumstances;
	}

	dispatch(postScheduledHours(employeeId, employmentId, postPayload, () => {
		// on success, set success message and then fetch employment data (which has scheduled hours on it) again
		if (formValues?.changeDueToIllness || formValues?.extenuatingCircumstances) {
			dispatch(setDecreaseInScheduledHoursStatus(ApiStatuses.Success));
		} else
			dispatch(setUpdateScheduledHoursStatus(ApiStatuses.Success));
		dispatch(getEmployment(employeeId, employmentId, dispatchSetEmployment(dispatch), () => dispatchSetEmploymentFailed(dispatch)));
		onSuccess();
	}));
};

export const patchScheduledHoursRequest = (
	dispatch: Dispatch<any>,
	employeeId: number | string,
	employmentId: number,
	savedValues: ScheduledHoursFormValues,
	formValues: ScheduledHoursFormValues,
	currentScheduledHours: ScheduledHours,
	onSuccess: any) => {

	const changed = parseChanged(savedValues, formValues);

	if (isEmpty(changed)) {
		return;
	}

	dispatch(apiErrorClear());

	const payload = {
		scheduled_hour: {
			hours: formValues.hours,
		},
		employee_id: employeeId,
		employment_id: employmentId,
		id: currentScheduledHours?.id,
	};

	const patchSuccess = (responseData: ScheduledHours) => {
		dispatch(updateScheduledHours(responseData));
		dispatch(setUpdateScheduledHoursStatus(ApiStatuses.Success));
		onSuccess();
	};

	dispatch(patchScheduledHours(employeeId, employmentId, currentScheduledHours.id, payload, (patchResponse) => {
		patchSuccess(patchResponse.data);
	}));
};